import { Typography } from '@doltech/ui/lib/figma/DesignSystemV2/Typography';
import { DolTooltip } from '@doltech/ui/lib/figma/Tooltip/DolTooltip';
import { SkillEnum } from '@doltech/utils/lib/constants';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import styled from 'styled-components';

import { useTestSubmissionStore } from '../model/test-submissions.hook';
import { ElementNavbarSectionQuestion } from './ElementNavbarSectionQuestion/ElementNavbarSectionQuestion';
import { flexGap } from '@doltech/utils/lib/css-style';

interface TestProgressProps extends React.HTMLAttributes<HTMLDivElement> {}

const Main = styled.div`
  display: flex;
  align-items: center;
  ${flexGap(8)};
  padding: 0 16px;

  .button-test-section {
    margin-right: 28px;
    &:last-child {
      margin-right: 0;
    }
  }
`;

export const TestProgress = observer((_props: TestProgressProps) => {
  const store = useTestSubmissionStore();

  const { isReviewing } = store;
  const activeSection = store.currentSectionIndex;

  const renderNoneChangeSectionMessage = React.useCallback((currentSection, nextSection) => {
    return (
      <Typography.Text variant="semi-bold/16-24" color="white100">
        <div>Không thể chuyển section {nextSection}.</div>
        <div>Bạn phải nghe hết section {currentSection}.</div>
      </Typography.Text>
    );
  }, []);

  const renderButtonTestSection = (testSection, index) => {
    const { id, skill, totalAnswerInGroup } = testSection;
    const isActive = activeSection === index && !store.isReviewing;
    const name = skill === SkillEnum.LISTENING ? 'Section' : 'Passage';

    return (
      <ElementNavbarSectionQuestion
        key={id}
        text={`${name} ${index + 1}`}
        answeredQuestions={totalAnswerInGroup || 0}
        totalQuestions={testSection.totalQuestionInGroup}
        active={isActive}
        onClick={() => {
          if (store.preventUserAction()) return;
          store.goToSectionIndex(index);
        }}
      />
    );
  };

  return (
    <Main className="test-progress">
      {store.testSections.map((testSection, index) => {
        if (
          !isReviewing &&
          store.currentSectionIndex < index &&
          store.skill === SkillEnum.LISTENING
        ) {
          return (
            <DolTooltip
              key={index}
              trigger={['click']}
              title={() => renderNoneChangeSectionMessage(activeSection + 1, index + 1)}
              placement="left-start"
            >
              {renderButtonTestSection(testSection, index)}
            </DolTooltip>
          );
        }
        return renderButtonTestSection(testSection, index);
      })}
    </Main>
  );
});
